// extracted by mini-css-extract-plugin
export var closeButton = "_7w-0";